// extracted by mini-css-extract-plugin
export default {"mCard":"XA-z","image":"YA-z","imageNoBackground":"ZA-z","imageHasCategory":"_A-z","fullWidth":"aB-z"};